/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StringResources from 'nls/StringResources';
import VisualItem from './VisualItem';

import {
	FlexItem,
	FlexLayout,
	Label,
	SVGIcon,
	VSpacer
} from '@ba/ba-ui-carbon-toolkit';
import '../../../stylesheets/all.scss';

// search_16 is placeHolder.
import emptySearchResults from '@ba/ba-graphics/dist/icons-js/search_16.js';
//import emptySearchResults from '@ba/ba-graphics/dist/illustrations-js/search-results_128.js';

export default class VisualItems extends Component {
	static propTypes = {
		items: PropTypes.array.isRequired,
		files: PropTypes.array.isRequired,
		selections: PropTypes.array.isRequired,
		searchMatches: PropTypes.array, // can be null means no search at all, show all items.
		selectVisualItemCallback: PropTypes.func.isRequired,
		deSelectAllCallback: PropTypes.func.isRequired
	};

	constructor(props) {
		super(props);
	}

	/* componentWillReceiveProps(nextProps) {
	} */

	renderVisualizationItem(item, fileRef, selected, idx ) {
		// remove the props we don't want to pass to each child
		return (
			<VisualItem {...this.props} key={item.source} item={item} fileRef={fileRef} selected={selected} idx={idx}/>
		);
	}

	_renderEmptySearchResults = () => {
		const { searchMatches } = this.props;
		if (searchMatches && searchMatches.length === 0)
			return (
				<FlexLayout
					direction='column'
					width='100%'
					height='100%'
					alignItems='center'
					justifyContent='center'
				>
					<FlexItem>
						<FlexItem>
							<SVGIcon
								width={150}
								height={150}
								focusable={false}
								intent='info'
								className='svgIcon'
								verticalAlign={'middle'}
								iconId={emptySearchResults.id}
							/>
						</FlexItem>
						<FlexItem>
							<VSpacer size={2} />
						</FlexItem>
						<FlexItem>
							<Label label={StringResources.get('schematicsEmptySearchResults')}/>
						</FlexItem>
					</FlexItem>
				</FlexLayout>);
	}

	render () {
		const { items, files, selections, searchMatches } = this.props;
		const contentItems = [];
		items.forEach((item, idx) => {
			let selected = selections.indexOf( idx ) !== -1;
			if ( searchMatches && searchMatches.indexOf(idx) !== -1 || !searchMatches  )
				contentItems.push(this.renderVisualizationItem(item, files[idx], selected, idx));
		});

		return (
			<FlexLayout
				direction='row'
				wrap='wrap'
				alignItems={'flex-start'}
				justifyContent={'flex-start'}
				style={ { alignContent:'flex-start' } }
				className='clsSVGTilesStyle'
				onClick={ (e) => {
					e.stopPropagation();
					this.props.deSelectAllCallback();
				} }
			>
				{this._renderEmptySearchResults()}
				{contentItems}
			</FlexLayout>
		);
	}

}



// WEBPACK FOOTER //
// ./src/js/dialog/schematic/VisualItems.js